const FETCH_REPORT_DETAIL = 'FETCH_REPORT_DETAIL';
const FETCH_REPORT_DETAIL_SUCCESS = 'FETCH_REPORT_DETAIL_SUCCESS';
const FETCH_REPORT_DETAIL_ERROR = 'FETCH_REPORT_DETAIL_ERROR';
const CREATE_REPORT_DETAIL = 'CREATE_REPORT_DETAIL';
const CREATE_REPORT_DETAIL_SUCCESS = 'CREATE_REPORT_DETAIL_SUCCESS';
const CREATE_REPORT_DETAIL_ERROR = 'CREATE_REPORT_DETAIL_ERROR';
const UPDATE_REPORT_DETAIL = 'UPDATE_REPORT_DETAIL';
const UPDATE_REPORT_DETAIL_SUCCESS = 'UPDATE_REPORT_DETAIL_SUCCESS';
const UPDATE_REPORT_DETAIL_ERROR = 'UPDATE_REPORT_DETAIL_ERROR';
const IS_ADDING_UPDATE = 'IS_ADDING_UPDATE';
const SET_REPORT_DETAIL_MANAGER_STATE = 'SET_REPORT_DETAIL_MANAGER_STATE';

export {
  FETCH_REPORT_DETAIL,
  FETCH_REPORT_DETAIL_SUCCESS,
  FETCH_REPORT_DETAIL_ERROR,
  CREATE_REPORT_DETAIL,
  CREATE_REPORT_DETAIL_SUCCESS,
  CREATE_REPORT_DETAIL_ERROR,
  UPDATE_REPORT_DETAIL,
  UPDATE_REPORT_DETAIL_SUCCESS,
  UPDATE_REPORT_DETAIL_ERROR,
  IS_ADDING_UPDATE,
  SET_REPORT_DETAIL_MANAGER_STATE,
};
